import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { History } from "lucide-react";
import { StatutsUpdateDialog } from "@/components/legal/StatutsUpdateDialog";

const STATUS = { draft: ["Brouillon", "bg-amber-100 text-amber-800"], validated: ["En vigueur", "bg-emerald-100 text-emerald-700"], superseded: ["Archivée", "bg-slate-100 text-slate-500"] };

export const StatutsVersionsCard = ({ refreshKey, onChanged }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/legal/statuts/versions").then((r) => setRows(r.data.versions)).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  if (rows.length === 0) return null;
  return (
    <Card data-testid="statuts-versions">
      <StatutsUpdateDialog versionId={open} onClose={() => setOpen(null)} onChanged={() => { load(); onChanged?.(); }} />
      <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2"><History className="w-4 h-4" />Versions des statuts</CardTitle></CardHeader>
      <CardContent className="divide-y">
        {rows.map((v) => (
          <button key={v.id} onClick={() => setOpen(v.id)} className="w-full text-left py-2 flex items-center gap-3 hover:bg-slate-50 px-1 rounded" data-testid={`statuts-version-${v.version}`}>
            <span className="font-mono text-sm w-10">v{v.version}</span>
            <span className="flex-1 text-sm">{v.label}</span>
            <span className="text-xs text-slate-500">{new Date(v.created_at).toLocaleDateString("fr-FR")}</span>
            <Badge className={`${STATUS[v.status]?.[1]} text-[10px]`}>{STATUS[v.status]?.[0]}</Badge>
          </button>
        ))}
      </CardContent>
    </Card>
  );
};
